import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChild,
  Inject,
  input,
  Optional,
} from '@angular/core';
import { FormControl, NgControl, Validators } from '@angular/forms';
import {
  ERROR_MESSAGES_TOKEN,
  ErrorMessages,
} from '../../injection-tokens/error-messages-token';

@Component({
  selector: 'otw-form-field',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-field.component.html',
  styles: `.required::after{
    content: "*";
    color: red;
  }`,
})
export class FormFieldComponent implements AfterContentInit {
  label = input('');
  for = input('');
  classNames = input('');
  labelClassNames = input('');

  showError = false;
  errorMessage = '';
  required = false;

  @ContentChild(NgControl) _formFieldControl: NgControl | undefined;

  get control(): FormControl | null {
    return (this._formFieldControl?.control as FormControl) || null;
  }

  get controlName() {
    return this._formFieldControl?.name;
  }

  constructor(
    @Optional()
    @Inject(ERROR_MESSAGES_TOKEN)
    private errorMessages: ErrorMessages | undefined
  ) {}

  ngAfterContentInit(): void {
    this.required = this.control?.hasValidator(Validators.required) || false;
  }

  getErrorMessage(): string {
    const control = this.control;
    if (!control || !control.errors || !this.controlName) return '';

    if (control.errors['required']) {
      return 'Полето е задължително.';
    }

    if (!this.errorMessages) return 'Невалидна стойност.';

    const fieldErrors = this.errorMessages[this.controlName] || {};
    for (const errorKey in control.errors) {
      const message = fieldErrors[errorKey] || control.getError(errorKey);
      if (!message) return '';

      return typeof message === 'function'
        ? message(control.errors[errorKey])
        : message;
    }

    return 'Невалидна стойност.';
  }
}
